import { configureStore } from "@reduxjs/toolkit";
// import valueReducer from 'app/redux/reducers/valueSlice'
import { app } from "app/redux/reducers/app";
import { value } from "app/redux/reducers/value";
import { values } from "app/redux/reducers/values";
import { preferences } from "app/redux/reducers/preferences";
import { filters } from "app/redux/reducers/filters";
import { chapters } from "app/redux/reducers/chapters";
import { dragging } from "app/redux/reducers/dragging";
import { listeners } from "app/redux/reducers/listeners";
// import valuesReducer from 'app/redux/reducers/valuesSlice'
// import preferenceReducer from 'app/redux/reducers/preferenceSlice'

export default configureStore({
  reducer: {
    app,
    preferences,
    filters,
    value,
    values,
    chapters,
    dragging,
    listeners,
  },
});
